// src/components/ConversationList.js
import React from 'react';
import styled from 'styled-components';
import ConversationPreview from './ConversationPreview';

const ConversationList = ({ conversations, onConversationClick }) => {
  return (
    <Container>
      <h2>Chats</h2>
      {conversations.map((conversation) => (
        <ConversationPreview
          key={conversation.thread_id}
          conversation={conversation}
          onClick={() => onConversationClick(conversation)}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  border-right: 1px solid #ccc;
  overflow-y: auto;
  padding: 10px;
`;

export default ConversationList;
